import { render, staticRenderFns } from "./ArrowDownBase.vue?vue&type=template&id=74c70de2&scoped=true&"
import script from "./ArrowDownBase.vue?vue&type=script&lang=ts&"
export * from "./ArrowDownBase.vue?vue&type=script&lang=ts&"
import style0 from "./ArrowDownBase.vue?vue&type=style&index=0&id=74c70de2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c70de2",
  null
  
)

export default component.exports